export function dateOnlyKey(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function todayDateOnly(now: Date = new Date()): string {
  return dateOnlyKey(now);
}

export function toNoonUtcIso(dateOnly: string): string {
  return `${dateOnly}T12:00:00.000Z`;
}

export function parseDateOnly(value: string): Date | null {
  const date = new Date(toNoonUtcIso(value.trim()));
  return !Number.isNaN(date.getTime()) && dateOnlyKey(date) === value.trim() ? date : null;
}
